// RamsSupportingContextPicker — Phase 7: optional extra AI grounding context
// for one RAMS draft generation. The project's own CPP (if any) is used
// automatically; the reviewer can also tick specific Document Library files
// from the SAME project (e.g. a client-supplied CPP Word/PDF) to include.
import { useEffect, useState } from "react";
import { FileCheck2 } from "lucide-react";
import { api } from "@/lib/api";

export default function RamsSupportingContextPicker({ requestId, selectedIds, onChange }) {
    const [options, setOptions] = useState(null);

    useEffect(() => {
        api.get(`/rams/requests/${requestId}/context-options`)
            .then((r) => setOptions(r.data))
            .catch(() => setOptions({ cpp: null, documents: [] }));
    }, [requestId]);

    if (!options || (!options.cpp && options.documents.length === 0)) return null;

    const toggle = (id) => onChange(selectedIds.includes(id) ? selectedIds.filter((x) => x !== id) : [...selectedIds, id]);

    return (
        <div data-testid="rams-context-picker" className="p-2.5 rounded-lg bg-[#FBFAF8] border border-[#F0EDE8] space-y-1.5">
            <p className="text-[10.5px] font-semibold uppercase tracking-wider text-[#9A968F]">Supporting context for this generation</p>
            {options.cpp && (
                <p data-testid="rams-context-cpp-note" className="text-[11.5px] text-[#4B4741] flex items-center gap-1.5">
                    <FileCheck2 size={12} className="text-emerald-600 shrink-0" />
                    This project's Construction Phase Plan ({options.cpp.reference}) will be used automatically.
                </p>
            )}
            {options.documents.length > 0 && (
                <div className="space-y-1">
                    <p className="text-[11px] text-[#9A968F]">Optionally include from this project's Document Library:</p>
                    {options.documents.map((d) => (
                        <label key={d.id} data-testid={`rams-context-doc-${d.id}`} className="flex items-center gap-2 text-[11.5px] text-[#4B4741] cursor-pointer">
                            <input type="checkbox" checked={selectedIds.includes(d.id)} onChange={() => toggle(d.id)} />
                            {d.title || d.filename} <span className="text-[#9A968F]">({d.filename})</span>
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
}
